import React, { useState } from 'react';
import { TableRow, TableCell, Button, Divider, List, ListItem } from '@material-ui/core';

import { Delete, Edit } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import usePermissions from 'utils/usePermissions';

export function CatalogueItem({ catalogue, onDelete, onEdit, vatPerCent }) {
  const { canCrudCatalogAndVat } = usePermissions();
  const [catalogIsDeleting, setCatalogIsDeleting] = useState(false);

  const handleDelete = async () => {
    try {
      setCatalogIsDeleting(true);
      await onDelete();
      setCatalogIsDeleting(false);
    } catch (err) {
      setCatalogIsDeleting(false);
    }
  };

  return (
    <TableRow>
      <TableCell>{catalogue.codigo}</TableCell>
      <TableCell>{catalogue.descripcion}</TableCell>
      <TableCell>{catalogue.disponible}</TableCell>
      <TableCell>{catalogue.nombreBodega}</TableCell>
      {canCrudCatalogAndVat && <TableCell>{Math.round(catalogue.precio * (1 + vatPerCent / 100) * 100) / 100}</TableCell>}
      <TableCell>{catalogue.medida}</TableCell>
      <TableCell>{catalogue.category && <FormattedMessage id={`categories.${catalogue.category}`} />}</TableCell>
      <TableCell>{catalogue.subcategory && <FormattedMessage id={`subcategories.${catalogue.subcategory}`} />}</TableCell>
      <TableCell align={canCrudCatalogAndVat ? 'auto' : 'right'}>{catalogue.categoria}</TableCell>
      {canCrudCatalogAndVat && <TableCell>{catalogue.status}</TableCell>}
      {canCrudCatalogAndVat && (
        <TableCell align="right">
          <Button disabled={catalogIsDeleting}>
            <Delete onClick={handleDelete} />
          </Button>
          <Button disabled={catalogIsDeleting}>
            <Edit onClick={onEdit} />
          </Button>
        </TableCell>
      )}
    </TableRow>
  );
}

export function MobileCatalogueItem({ catalogue, onDelete, onEdit, vatPerCent }) {
  const { canCrudCatalogAndVat } = usePermissions();
  return (
    <List style={{ marginTop: '16px' }}>
      <Divider />
      <ListItem>
        <FormattedMessage id="catalogue.codigo" description="Codigo" />:{catalogue.codigo || '---'}
      </ListItem>
      <ListItem>
        <FormattedMessage id="catalogue.descripcion" description="Descripcion" />: {catalogue.descripcion || '---'}
      </ListItem>
      <ListItem>
        <FormattedMessage id="catalogue.disponible" description="Disponible" />: {catalogue.disponible || '---'}
      </ListItem>
      <ListItem>
        <FormattedMessage id="catalogue.nombreBodega" description="Nombre Bodega" />: {catalogue.nombreBodega || '---'}
      </ListItem>
      {canCrudCatalogAndVat && (
        <ListItem>
          <FormattedMessage id="catalogue.precio" description="Precio" />:{' '}
          {Math.round(catalogue.precio * (1 + vatPerCent / 100) * 100) / 100 || '---'}
        </ListItem>
      )}
      <ListItem>
        <FormattedMessage id="catalogue.medida" description="Medida" />: {catalogue.medida || '---'}
      </ListItem>
      <ListItem>
        <FormattedMessage id="catalogue.category" description="Category" />:{' '}
        {catalogue.category && <FormattedMessage id={`categories.${catalogue.category}`} />}
      </ListItem>
      <ListItem>
        <FormattedMessage id="catalogue.subcategory" description="Category" />:{' '}
        {catalogue.subcategory && <FormattedMessage id={`subcategories.${catalogue.subcategory}`} />}
      </ListItem>
      <ListItem align={canCrudCatalogAndVat ? 'left' : 'right'}>
        <FormattedMessage id="catalogue.price_category" description="price_category" />: {catalogue.categoria}
      </ListItem>
      {canCrudCatalogAndVat && (
        <ListItem align="right">
          <Button>
            <Delete onClick={onDelete} />
          </Button>
          <Button>
            <Edit onClick={onEdit} />
          </Button>
        </ListItem>
      )}
    </List>
  );
}
